module.exports = __webpack_public_path__ + "static/media/bcbs.f25c9e77.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/images/partner/logos/bcbs.png
// module id = 30
// module chunks = 0